import { StateToken } from '@ngxs/store';
import { ITrainingHistoryState } from './training-history.state';

export const TRAINING_HISTORY_TOKEN = new StateToken<ITrainingHistoryState>('trainingHistory');
